
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  Grid, Button, Modal, createStyles, Switch, Group, Alert } from '@mantine/core';
import {  clear_usertosignsent, update_DocsPrepareTemp_Status } from '../../slice/mainslice'
import { Edit   } from 'tabler-icons-react';
import NotarSetupSignsInDoc from "./NotarSetupSignsInDoc";
import intl from "react-intl-universal";

const useStyles = createStyles((theme) => ({
  sigcountdiv: {
    maxWidth: `25px`,
  },
  trackLabelsize: {
    fontSize: `12px`,
  },
}));


 


/**
 * Renders a component that allows the user to prepare documents for a setup.
 *
 * @param {Object} props - The properties for the component.
 * @param {boolean} props.isSigPrepared - The initial value of the isSigPrepared state.
 * @param {string} props.drnId - The ID of the document.
 * @param {string} props.resourceId - The ID of the resource.
 * @return {JSX.Element} The rendered component.
 */

const SetupPrepareDocs = (props: any) => {
  const { classes } = useStyles();
    const dispatch = useDispatch();
    

    const [openedfull, setOpenedFull] = useState(false);
    const [isSigPreparedstatus, setisSigPreparedstatus] = useState(props.isSigPrepared);
    const userhavetosigndocs = useSelector((state: any) => state.user.userhavetosigndocs)
    const usertosignsent = useSelector((state: any) => state.user.usertosignsent)

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [signatureBlockCount, setSignatureBlockCount] = useState(0);

    const signatureBlockMeetings  = useSelector((state: any) => state.user.meetingdocs)
    // Switch state
    const [checked, setChecked] = useState(props.isSigPrepared);
    const [resetblockprompt, setResetblockprompt] = useState(false);
    const [restpropen, setRestpropen] = useState(false);
    const initialRender = useRef(false);

   

    useEffect(() => {
      
       const signatureBlockData = signatureBlockMeetings.filter((obj: { resourceId: any; }) => {
        return obj.resourceId === props.resourceId;
     });
     setSignatureBlockCount(signatureBlockData[0].signatureBlockCount)

    /* const ckeckuserondoc= userhavetosigndocs.find((itemdata: { resourceId: any; }) => itemdata.resourceId === props.resourceId);
     console.log(ckeckuserondoc.user.length)
     if (ckeckuserondoc.user.length === 0){
      setChecked(false)
     }
    */


     // Check if SigBlock Toogle is activ or not
     const isDocumentPrepared = (props: { resourceId: any; }, signatureBlockMeetings: any[]): boolean => {
      return signatureBlockMeetings.some(
        (signatureBlockMeetings) => signatureBlockMeetings.isSigPrepared && signatureBlockMeetings.resourceId === props.resourceId
      );
    };

    const result = isDocumentPrepared(props, signatureBlockMeetings);
    setChecked(result)
    //console.log("result",result)


    }, [props,signatureBlockMeetings,userhavetosigndocs]);
    

    const toogleswitch = (checked: boolean) => {
      if (checked) {
        handleOpenFull();
      } if (!checked) {
        handleOpenResetPrompt();
      }
    };
   

    /**
     * Handle Modal Window.
     *
     * @return {void} 
     */
    const handleOpenFull = () => {
        setOpenedFull(true);
        setUserToDocBlocksetup();
      };
    
      /*const handleCloseFull = () => {
        setOpenedFull(false);
      };*/

      /**
     * Handle Modal Prompt Window zu zurücksetzten.
     *
     * @return {void} 
     */

      const handleOpenResetPrompt = () => {
        setResetblockprompt(true);
      };
  
      const handleCloseResetPrompt = () => {
        setResetblockprompt(false);
      };  

      const handleResetPromptYesClick = () => {
        resetDocissetup() 
        handleCloseResetPrompt();
      };
    
      const handleResetPromptNoClick = () => {
        setRestpropen(true);
        setChecked(true)
        handleCloseResetPrompt();
      };   

      
    /**
     * Handle SetupState for Sig Block ist set or not.
     *
     * @return {void} 
     */
      const setDocissetup = () => {
        
        const setdocisprepareddata = {
          drnId: props.drnId,
          resourceId: props.resourceId,
          isSigPrepared: true    
      };

      const temppreparedata = {
          resourceId: props.resourceId,
          isSigPrepared: true 
      }


      //console.log("setdocisprepareddata",setdocisprepareddata)
      //console.log("temppreparedata",temppreparedata)

       dispatch({ type: 'SIGNALR_SENDSETDOCISPREPARED', payload: setdocisprepareddata });
       dispatch(update_DocsPrepareTemp_Status(temppreparedata))
       setisSigPreparedstatus(true)
       setOpenedFull(false);
      };

      const resetDocissetup = () => {
      const setdocisprepareddata = {
          drnId: props.drnId,
          resourceId: props.resourceId,
          isSigPrepared: false  
      };

      const temppreparedata = {
        resourceId: props.resourceId,
        isSigPrepared: false  
      }

      const resetdocisprepareddata = {
        drnId: props.drnId,
        resourceId: props.resourceId,
      };
        
      
      dispatch({ type: 'SIGNALR_SENDSETDOCISPREPARED', payload: setdocisprepareddata });
       
       setTimeout(() => {
        dispatch({ type: 'SIGNALR_SENDRESETPREPARESIGNATURELAYOUT', payload: resetdocisprepareddata });
       }, 1000); // Delay for 1 second (1000 milliseconds)
     
       dispatch(update_DocsPrepareTemp_Status(temppreparedata))
       //setisSigPreparedstatus(false)
       setOpenedFull(false);
      };

     



    /**
     * Handle Sent User to DRN fpr config Sig Block iframe.
     *
     * @return {void} 
     */
    const setUserToDocBlocksetup = () => {
      dispatch(clear_usertosignsent())
      const userarray = userhavetosigndocs.find((itemdata: { resourceId: any; }) => itemdata.resourceId === props.resourceId);
       
      //console.log("userarray",userarray)

      const setdocSigblockuser = {
        drnId: props.drnId,
        DocumentResourceId: props.resourceId,
        userIds: userarray.user   
    };
   
    dispatch({ type: 'SIGNALR_SENDSETUSERFORSIGBLOCKSETUP', payload: setdocSigblockuser });

    };

      let color
      if (checked === true) {
        color = "green"
      } else {
        color = ""
      } 

     
   //  console.log("checked",checked)

        return (
            <>
              <Group>
              <Switch classNames={{trackLabel: classes.trackLabelsize}} checked={checked} color={color} onLabel="on" onChange={(event) => toogleswitch(event.currentTarget.checked)} />
                 {checked &&
                    <Edit color={color} strokeWidth={0.8} onClick={() => handleOpenFull()}/>
                 }
              </Group>
            
                
                <Modal
                    opened={openedfull}
                    onClose={setDocissetup}
                    title=""
                    fullScreen
                    withCloseButton={false}
                    closeOnClickOutside={false}
                    transitionProps={{ transition: 'fade', duration: 200 }}
                    >

                      {usertosignsent && 
                    <>
                    
                    <Group position="right">
                        <Button color="green" onClick={setDocissetup}>{intl.get('SETSIGBLOCKDOC_MOD_BUTYES')}</Button>
                        <Button color="gray" onClick={setDocissetup}>{intl.get('ENDMEETING_NEWTERM_BUTTON_NO')}</Button>
                     </Group>
                    </>
                    }

                    <> 
                    {usertosignsent !== undefined &&
                    <NotarSetupSignsInDoc resourceId={props.resourceId} usertosignsent={usertosignsent}/>
                   }
                    
                    </>  
                       
                 
                    </Modal>

                    <Modal
        title=""
        opened={resetblockprompt}
        onClose={handleCloseResetPrompt}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        zIndex={10000}
        >
          {intl.get('SIGBLOCK_PRO_HEAD')} 
          <Alert  color="red"> 
          {intl.get('SIGBLOCK_PRO_TEXT')} 
         </Alert>
          
          <hr />
          
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={handleResetPromptYesClick}  >{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="gray" variant="light" onClick={handleResetPromptNoClick} >{intl.get('DIALOG_BUTTON_NO_CLOSE')}</Button>
            </Grid.Col>
          </Grid>
         
      </Modal> 
            </>
        );
    };

    


export default SetupPrepareDocs;